import MuiSpeedDialAction, {
  SpeedDialActionProps,
} from '@mui/material/SpeedDialAction';
import type { SxProps, Theme } from '@mui/material/styles';
import { themeColors } from '../ThemeProvider/AvenyThemeColors';

interface IProps extends Omit<SpeedDialActionProps, 'slotProps'> {
  glass?: boolean;
  disabled?: boolean;
}

export const EDSpeedDialAction: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { glass, disabled, ...restProps } = props;
  const glassFabSx: SxProps<Theme> = {
    border: `1px solid ${themeColors.customGlass.buttonBorder}`,
    boxShadow: `0px 8px 32px ${themeColors.customGlass.buttonShadow}`,
    backdropFilter: 'blur(24px) saturate(0.8)',
    backgroundColor: themeColors.customGlass.buttonBackground,
    color: themeColors.customGlass.buttonColor,
    '&& .MuiSvgIcon-root, && .MuiIcon-root': {
      color: `${themeColors.customGlass.buttonColor}`,
    },
    '&&.Mui-disabled': {
      backgroundColor: themeColors.customGlass.buttonBackground,
    },
    '&&.Mui-disabled .MuiSvgIcon-root, &&.Mui-disabled .MuiIcon-root': {
      color: (theme: Theme) => theme.palette.action.disabled,
    },
  };

  const slotProps = {
    fab: {
      disabled: disabled,
      sx: glass ? glassFabSx : restProps.sx,
    },
  };

  return <MuiSpeedDialAction {...restProps} slotProps={slotProps} />;
};
